module.exports = __webpack_public_path__ + "img/Daniel.391cae06.jpg";